import { useEffect } from "react"

export const useInputTextMouseWheel = () => {
  let inputs: NodeListOf<HTMLInputElement> = document.querySelectorAll("input[type=number]")

  useEffect(() => {
    const onWheel = (event: MouseEvent) => {
      event.preventDefault()
    }

    inputs.forEach((input) => {
      input.addEventListener("wheel", onWheel);
    })

    return () => {
      inputs.forEach((input) => {
        input.removeEventListener("wheel", onWheel);
      })
    }
  }, [inputs])
}
